<svelte:options tag="unescap-header" />

<script>
  import { onMount } from 'svelte';
  // import bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
  import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';

  // const drupalApiDomain = 'http://localhost';
  const drupalApiDomain = window.location.origin;  // process.env.DRUPAL_API_DOMAIN;
  const moonDomain = 'https://venus.thinkbluedata.com';
  const isLogin = window.localStorage.getItem('escap.isLogin');
  const isCountryProfile = location.href.includes('#country-profile');
  const isRuLang = location.href.includes('/ru');
  let collapseMenuRef;
  let isHamburgerMenuOpen = false;
  let menuData = [];
  let userInfo = 'Unknown user';
  onMount(async () => {
    // console.log(collapseMenuRef);
    // const dropdownToggleList = [].slice.call(collapseMenuRef.querySelectorAll('.dropdown-toggle'));
    // const dropdownList = dropdownToggleList.map((dropdownToggle) => {
    //   return new bootstrap.Dropdown(dropdownToggle);
    // });
    const _menuData = await _getMenuData();
    menuData = _menuData.map(menuItem => {
      menuItem.active = isMenuItemActive(menuItem);
      menuItem
      return menuItem;
    });

    if (isLogin === false) { return; }
    _setUserInfo();
  });

  async function _getMenuData () {
    const menuDataResponse = await fetch(`${drupalApiDomain}${(isRuLang ? '/ru' : '')}/api/menu_items/unescap`);
    return await menuDataResponse.json();
  }
  async function _setUserInfo () {
    const token = localStorage.getItem('escap.access_token');
    if (token === null || token === 'undefined') { return; }

    const headers = { authorization: `Bearer ${token}` };
    const userResponse = await fetch(`${moonDomain}/1/users/current_data`, { headers: headers });
    const user = await userResponse.json();
    localStorage.setItem('escap.role', user.role);
    userInfo = `${user.email} [${user.role}]`;
  }
  function handleHamburgerClick () {
    isHamburgerMenuOpen = !isHamburgerMenuOpen;
  }
  function handleLoginMenuClick () {
    localStorage.setItem('escap.returnUrl', location.href);
    location.href = moonDomain + '/oauth/authorize?client_id=10fd58d46cb5f8eb07e6664962824e728a029f97ea23fbfc346d092b3d249f5d&redirect_uri='
        + encodeURIComponent(`${location.origin}/apef/callback.html`)
        + '&response_type=code';
  }
  function handleLogoutMenuClick () {
    localStorage.removeItem('escap.access_token');
    localStorage.removeItem('escap.token_info');
    localStorage.removeItem('escap.hash');
    localStorage.removeItem('escap.isLogin');
    localStorage.removeItem('escap.role');

    const logoutWindow = window.open(`${moonDomain}/admin/logout`, '_blank', 'width=10, height=10');
    setTimeout(async function () {
      logoutWindow.close();
      const userGuestResponse = await fetch(`${moonDomain}/1/users/guest`);
      const user = await userGuestResponse.json();
      localStorage.setItem('escap.access_token', user.token.token);
      localStorage.setItem('escap.role', 'guest');
      location.reload();
    }, 800); // Wait for window open
  }
  function handleMenuClick (selectedMenuItem) {
    menuData = menuData.map(menuItem => {
      menuItem.active = menuItem.key === selectedMenuItem.key;
      return menuItem;
    });
  }
  function getUrl (menuItem) {
    const origin = location.origin;
    const replaceLocalhost = menuItem.absolute.replace('http://localhost', origin);
    if (isRuLang === false) {
      return replaceLocalhost;
    }

    return replaceLocalhost.replace('/lang/en', '/lang/ru');
  }
  function isMenuItemActive (menuItem) {
    function isCurrentPath (path) {
      if (location.hash === '') {
        return false;
      }
      return decodeURI(path).includes(location.hash);
    }
    if (menuItem.below) {
      const activateChildren = menuItem.below.find(menuChildren => {
        return isCurrentPath(menuChildren.absolute)
      });
      return activateChildren !== undefined;
    }

    return isCurrentPath(menuItem.absolute)
  }
  // function handleNavItemMouseenter (event) {
  //   _showHideDropdownMenu(event.currentTarget);
  // }
  // function handleNavItemMouseleave (event) {
  //   _showHideDropdownMenu(event.currentTarget);
  // }
  // function _showHideDropdownMenu ($navItem) {
  //   const $dropdownMenu = $navItem.querySelector('.dropdown-menu');
  //   $dropdownMenu.classList.toggle('show');
  // }
</script>



<nav
  class="navbar navbar-expand-xl navbar-light bg-light fixed-top pt-0 pt-xl-2"
  class:country-profile={isCountryProfile}
>
<!-- <div class="container" >
  <div class="row">
    <div class="col-12"> -->
    {#if isCountryProfile}
    <div class="container-country-info">
      <img class="country-flag" alt="Country Flag" />
      <span class="country-name"></span>
    </div>
    {:else}
    <div class="header-site-branding mt-xl-2">
      <ul class="menu-list">
        <li class="menu unescap-menu d-none d-sm-block"><a class="py-1 px-0" href="https://www.unescap.org/">
          <img
            alt="logo"
            onerror="this.src='/assets/images/notfound.png';"
            src="https://un-apef.thinkbluedata.com/sites/default/files/inline-images/ESCAP_LOGO/AW_ESCAP_LOGO_OFFICIAL.png"
            style="height: 42px;"
          /></a></li>
        <li class="divider d-none d-sm-block">&nbsp;</li>
        <li class="menu d-none d-sm-block"><a class="p-0" href="https://www.unescap.org/events/commission78">
          <img
          alt="logo"
          onerror="this.src='/assets/images/notfound.png';"
          src="https://un-apef.thinkbluedata.com/sites/default/files/inline-images/doa_un.png"
          style="height: 42px;"
        /></a></li>
        <li class="divider d-none d-sm-block">&nbsp;</li>
        <li class="menu sitebranding-menu">
          <a class="p-0" href="/">
            <img
              alt="logo"
              onerror="this.src='/assets/images/notfound.png';"
              src="https://un-apef.thinkbluedata.com/sites/default/files/inline-images/PORTAL_LOGO.png"
              style="height: 42px;"
            />
          </a></li>
      </ul>
      </div>

      
    {/if}
  
    <ul class="navbar-nav mr-auto  mt-lg-3 mt-xl-0" id="langNav">
      <li class="nav-item dropdown">
        {#if isLogin}
          <button
            aria-expanded="false"
            aria-haspopup="true"
            class="btn btn-link nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
          >{userInfo}</button>
          <div class="dropdown-menu" aria-labelledby="login">
            <button
              class="btn btn-link dropdown-item nav-dropdown-item"
              on:click={handleLogoutMenuClick}
            >Log Out</button>
          </div><!-- /.dropdown-menu -->
        {:else}
          <button
            class="btn btn-link nav-link"
            on:click={handleLoginMenuClick}
          >Log In</button>
        {/if}
      </li>
      <li class="nav-item" class:active={!isRuLang}>
        <a class="btn btn-link nav-link" href="/">ENG</a>
      </li>
      <li class="nav-item" class:active={isRuLang}>
        <a class="btn btn-link nav-link" href="/ru">РУС</a>
      </li>
      <li class="nav-item tutorial-link">
        <a class="btn btn-link nav-link tutorial-icon" target="_blank" href="/apef/tutorial.html">
          ?
        </a>
      </li>
    </ul><!-- /#langNav -->

  <button
    aria-controls="navbarNavDropdown"
    aria-expanded="false"
    aria-label="Toggle navigation"
    class="navbar-toggler m-2 px-2"
    data-bs-toggle="collapse"
    data-bs-target="#navbarNavDropdown"
    type="button"
    on:click={handleHamburgerClick}
  ><span class="navbar-toggler-icon"/></button>
  <div
    bind:this={collapseMenuRef}
    class="navbar-collapse collapse"
    class:show={isHamburgerMenuOpen}
    id="navbarNavDropdown"
  >

    <ul class="navbar-nav mr-auto" id="mainNav">
      {#each menuData as menuItem (menuItem.key)}
        <li
          class="nav-item "
          class:dropdown={menuItem.below}
          class:active={menuItem.active === true}
        >
          {#if menuItem.below}
            <a
              id={menuItem.key}
              href={getUrl(menuItem)}
              aria-expanded="false"
              aria-haspopup="true"
              class="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
            >{menuItem.title}</a>
            <div
              class="dropdown-menu"
              aria-labelledby={menuItem.key}
            >
              {#each menuItem.below as menuChildren (menuChildren.key) }
                <a
                  class="dropdown-item nav-dropdown-item"
                  href={getUrl(menuChildren)}
                  on:click={() => handleMenuClick(menuItem)}
                >{menuChildren.title}</a>
              {/each}
            </div><!-- /.dropdown-menu -->
          {:else}
            <a
              class="nav-link"
              href={getUrl(menuItem)}
              on:click={() => handleMenuClick(menuItem)}
            >{menuItem.title}</a>
          {/if}
        </li>
      {/each}
    </ul>
  </div>

<!-- </div>
</div>
</div> -->
</nav>


<style lang="scss">
@import 'https://un-apef.thinkbluedata.com/themes/custom/tbdtheme/assets/dist-webcomponents/svelte/bundle.css'; // Import hosted file to avoid incorrect relative path in built version

$HEADER-HEIGHT: 58px;
$LANG_NAV_HEIGHT: 25px;
$LANG_NAV_WIDTH: 55px;
$LOGIN_NAV_HEIGHT: 25px;
:host {
  display: block;
  height: $HEADER-HEIGHT;
}
.navbar {
  &.fixed-top {
    will-change: transform;
    font-size: 12px;
    color: #000;
    font-family: "Arial Narrow",Arial,sans-serif!important;
  }
  &.country-profile {
    .dropdown-item.nav-dropdown-item{
        color: rgba(0,0,0,.55) !important;
      }
    // * {
    //   color: #fff !important;
    // }
    .container-country-info {
      display: flex;
      margin-left: 60px;
      .country-flag {
        height: 38px;
      }
      .country-name {
        margin-left: 16px;
        font-size: 28px;
        color: #fff;
      }
    }
    .dropdown-menu {
      // background: rgba(39,39,39,.8);
      .dropdown-item {
        &:hover {
          background-color: #f8f9fa!important;
          color: rgba(0,0,0,.5)!important;
        }
      }
    }
  }
  height: $HEADER-HEIGHT;
  #langNav {
    flex-direction: row;
    position: absolute;
    right: 20px;
    top: 0;
    height: $LANG_NAV_HEIGHT;
    z-index: 2;
    // width: $LANG_NAV_WIDTH;
    .nav-item {
      &.active {
        .nav-link {
          font-weight: bold;
        }
      }
      &.login {
        & > .dropdown-menu {
          padding: 5px 0;
        }
        .nav-link {
          color: #4C5058;
        }
      }
      &.tutorial-link {
        display: flex;
        align-items: center;
        .tutorial-icon {
          width: 16px;
          height: 16px;
          border: 1px solid #f93;
          border-radius: 50%;
          background: #f93;
          color: #fff;
          font-weight: bolder;
          line-height: 12px;
        }
      }
      .nav-link {
        padding: 2px;
        font-size: 12px;
        // color: #337ab7;
        text-transform: uppercase;
      }
      .dropdown-menu {
        padding: 0;
        .nav-dropdown-item {
          font-size: 12px;
        }
      }
    }
  }
  #mainNav {
    position: absolute;
    right: 20px;
    top: $LOGIN_NAV_HEIGHT;
/*    text-transform: uppercase;*/
    .nav-item {
      &.active {
        .nav-link {
          color: #FF9933;
          font-weight: normal;
        }
      }
      .nav-link {
        &.active {
          color: #FF9933;
          font-weight: normal;
        }
        padding: 4px 8px;
        font-size: 16px;
      }
      .nav-dropdown-item {
        font-size: 16px;
      }
    }
  }
  .nav-item {
    cursor: pointer;
    &.dropdown {
      &:hover {
        &>.dropdown-menu {
          display: block;
        }
      }
    }
  }
}

.divider {
  height: 60%;
  border-right: 1px solid dimgray;
}
.header-site-branding {
  margin-left: 20px;
}
.header-site-branding>.menu-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
    gap: 1em;
    margin: 0;
    padding: 0;
    list-style: none;
}
.navbar-toggler {
  position: absolute;
  top: 0;
  right: 0;
}
.navbar-toggler:focus {
    box-shadow: none;
}
.navbar-toggler-icon {
    width: 1em;
    height: 1em;
}
@media only screen and (min-width: 1200px) {
  .navbar {
    &.country-profile {
      .nav-item * {
      color: #fff !important;
      }
      .dropdown-item .nav-dropdown-item{
        color: rgba(0,0,0,.55) !important;
      }
      .navbar-toggler {
        background: #fff;
        width: 44px;
        height: 34px;
      }
      .navbar-toggler-icon {
        width: 27px;
        height: 27px;
      }
    }
  }

}
@media only screen and (max-width: 1200px) {
  .navbar {
    #mainNav {
      padding: 15px 15px 15px 0;
      right: 0px;
      text-align: right;
      top: 58px;
      width: 140px;
      background-color: white;
      border: 1px solid rgba(0,0,0,.1);
    }
    #langNav {
    right: 60px;
    }
    &.country-profile {
      .navbar-toggler {
        background: #fff;
        width: 44px;
        height: 34px;
        margin-top: 12px !important;
        margin-right: 10px !important;
      }
      .navbar-toggler-icon {
        width: 27px;
        height: 27px;
      }
      #langNav * {
        color: #fff;
      }
    }
  }
  .navbar-nav .dropdown-menu {
    position: absolute;
    right: 123px;
    top: 0;
    border: 1px solid rgba(0,0,0,.1);
  }
}
@media only screen and (max-width: 576px) {
  .sitebranding-menu img {
    height: auto !important;
    width: 80%;
  }
}

</style>
